// UI texts: camp
export default {
  /** Package 4, part A.4: the First Week card (10. 10. 2026, owner: "First Steps", no days). */
  /** Package 4, part D: the week's bounty. */
  bounty: {
    heading: 'Wanted this week',
    ends: 'Ends in {t}',
    where: 'Shows up now and then on a run in {zone}.',
    reward: 'Beat it this week: +{shards} Relic Shards, +{score} Season Score.',
    done: 'Bounty collected',
    book: 'Named enemies',
  },
  firstWeek: {
    heading: 'First Steps',
    count: '{n}/{total}',
    /** 9. 10. 2026 (owner): the milestones instead of the days. */
    milestone: '{n} goals',
    rareItem: 'a Rare item',
    uncommonItem: 'an Uncommon item',
    title_: 'the title {title}',
    all: 'Show the whole list ({n} more)',
    less: 'Show less',
  },

  tag: 'Camp · Day {day} · {time}',
  onExpedition: 'On expedition',
  returnsIn: 'Returns in',
  /** Krug 5 (K4.15): the clock time next to a countdown. */
  backAt: 'back at {t}',
  readyAt: 'ready at {t}',
  headingHome: 'Heading home…',
  left: 'Left {time} · {run} run',
  viewRoute: 'View route',
  encounterAlert: 'Someone crossed your path — decide now',
  encounterSub: 'Your survivor is waiting for your call.',
  reportReady: 'Your survivor is back — read report',
  link: {
    /**
     * 20. 10. 2026 (owner, pilot report): when a guest first has something worth keeping (a Rare item or level 3), the
     * card is about keeping the survivor (2. 10. 2026 to then: "Email me when {name} is back").
     */
    title: 'Save your survivor',
    /** 29. 9. 2026: with the reward for linking (once per account). */
    body: "Link an email so you don't lose your progress: {name} stays yours on any device. Bonus: 3 Bandages, 50 Scrap, 20 Wood, 20 Metal and an Uncommon item.",
    link: 'Link email',
    later: 'Later',
    sheetTitle: 'Link your email',
    sheetBody: 'We email you a one-time link. Open it and this survivor is tied to your email, on any device.',
    email: 'Email address',
    send: 'Send link',
    bad: "That doesn't look like an email address.",
    sent: 'Check your inbox',
    sentBody: 'We sent a link to {email}. It works for 20 minutes.',
    devLink: 'Dev mode: open the link',
    off: 'Linking an email is not available right now.',
  },
  timers: {
    title: 'Timers',
    ready: 'Ready to pick up',
    next: 'Coming up',
    now: 'now',
    idle: { craft: 'Workbench is idle, start crafting', building: 'No building upgrade running' },
    /** Krug 5 (K4.15). */
    past: 'Past reports · {n} runs',
    pastOne: 'Past reports · 1 run',
  },
  /** Krug 5 (K4.16): the "Ready now" card at the top of the Camp. */
  ready: {
    title: 'Ready now',
    read: 'Read',
    claim: 'Claim',
    daily: 'Daily reward',
    contracts: '{n} contracts done',
    contractOne: 'A contract is done',
    attr: '{n} attribute points to spend',
    attrOne: '1 attribute point to spend',
    spend: 'Spend',
    skill: '{n} skill points to learn',
    skillOne: '1 skill point to learn',
    learn: 'Learn',
    upgrade: '{name} can go to LV {n}',
    build: '{name} can be built',
    /** Krug 5 (K9.2): from 80% full. */
    storageUpgrade: 'Storage {pct}% full · Upgrade to LV {n} ({cap})',
    storageFull: 'Storage {pct}% full',
    craft: 'Workshop is idle · {n} recipes you can make',
    craftOne: 'Workshop is idle · 1 recipe you can make',
    make: 'Craft',
    /** 2. 10. 2026 (package 1): the last run again in one tap (5.c), an idle crew (5.b). */
    same: 'Same orders · {zone} · {m}',
    send: 'Send',
    orders: 'Orders',
    // 11. 10. 2026 (owner, BACKLOG #33): the Barricade's scouts (was "Scavenging crew"; Crew is the players' crews).
    crew: 'Scouts are idle',
  },
  contracts: {
    title: 'Contracts',
    weekly: 'Weekly',
    resetsIn: 'new in {t}',
    weeklyReset: 'new in {t}',
    claim: 'Claim',
    claimed: 'Claimed',
    newIn: 'New contracts in {t}',
    newWeeklyIn: 'New weekly contract in {t}',
    /** 7. 10. 2026: the weekly by effort counts at most half its target a day. */
    dayCap: 'Counts up to {n} a day',
    dayDone: "Today's {n} are in. More counts tomorrow.",
    ready: '{n} ready to claim',
    difficulty: { easy: 'Easy', medium: 'Medium', hard: 'Hard' },
    /** 1. 10. 2026 (C2): the bonus item and energy (ENERGY_RULES.allContracts). */
    bonus: 'Claim all three: a bonus item and +{n} energy',
    bonusGiven: 'Bonus item and +{n} energy received',
    bonusToast: 'Bonus item: {name} · +{n} energy',
    tzPending: 'New time zone noticed. Contracts follow it from tomorrow.',
    swap: 'Swap',
    swapAria: 'Swap: {name}',
    swapLeft: 'One free swap left today.',
    swapUsed: 'Free swap used. A new one tomorrow.',
    crate: 'Uncommon or Rare item',
    crateChance: '{n}% chance of an item',
    locked: 'Contracts open after your second run.',
  },
  reportSub: 'Loot, fights and whatever happened out there.',
  atCamp: 'At camp',
  resting: 'Survivor is resting',
  planExpedition: 'Plan expedition',
  flavor: {
    /** 1. 10. 2026: a run up to {time} (ENERGY_RULES) costs 1 energy; never "a short run". */
    ready: 'Boots drying by the fire. {energy} energy: {energy} runs up to {time}, or fewer longer ones.',
    one: 'Boots drying by the fire. 1 energy: enough for one run up to {time}.',
    empty: 'Out of energy. Sit tight, the next point comes in {time}.',
    hurt: 'Patched up and aching. {hp}/{hpMax} HP — rest or heal before heading out.',
    critical: 'Barely standing. {hp}/{hpMax} HP. Going out like this is a gamble.',
  },
  heal: {
    title: 'Low HP',
    body: 'Use supplies from storage before the next run.',
    bandage: 'Bandage +{n}',
    medkit: 'Medkit +{n}',
    none: 'No bandages or medkits in storage. Craft some in the Workshop or wait it out.',
    notBack: 'Open the report first: your survivor is not back at camp yet.',
    healed: '+{n} HP',
  },
  daily: {
    title: 'Daily reward',
    dayOf: '· Day {day} of 7',
    claim: 'Claim',
    claimed: 'Claimed · come back tomorrow',
    sheetTitle: 'Daily reward',
    sheetBody: 'Come back every day. Missing two days starts the week over. Random supplies grow with your level.',
    day: 'Day {n}',
    today: 'Today',
    done: 'Claimed',
    claimNow: 'Claim day {n}',
    comeBack: 'Come back tomorrow',
  },
  ads: {
    energy: 'Watch ad: ',
    /**
     * Krug 5 (K17.2): the energy ad, only when energy is short. 28. 10. 2026 (player report): {n} = ENERGY_RULES.ad (1 since
     * 23. 10.); the text said +2.
     */
    energyReward: '+{n} energy · one more expedition',
    energyRewardLong: '+{n} energy toward a longer expedition',
    /** B6 (1. 10. 2026): what is really left (energy and heal, each once a day), not "of 3". */
    left: '— {n} left today',
    leftOne: '— 1 left today',
    none: '— no ads left today',
    used: '— used today',
    heal: 'Watch ad: ',
    healReward: 'instant full heal',
    sheetTitle: 'Sponsored break',
    placeholder: 'Ad',
    wait: 'Reward in {n} s',
    claiming: 'Collecting reward…',
    done: 'Reward collected',
    closeEarly: 'Closing now skips the reward.',
    success: { energy: '+{n} energy', heal: 'Fully healed' },
  },
  buildings: {
    upgrade: 'Upgrade',
    build: 'Build',
    needMore: 'Need {n} more',
    // 13. 10. 2026 (owner): a built building's next level waits for a survivor level ("Needs level 4 to upgrade"); one not
    // built yet unlocks at it.
    needLevel: 'Needs level {n} to upgrade',
    unlocksAt: 'Unlocks at level {n}',
    maxLevel: 'Max level',
    /** Krug 5 (K4.4b): "LV 6 / 10" (Storage has 10 levels, the others 5). */
    lvOf: 'LV {n} / {max}',
    /** Krug 5 (K4.17). */
    tracks: 'Your tracks lost {n} fights this week',
    tracksOne: 'Your tracks lost 1 fight this week',
    tracksSaved: 'Barricade saved {n} Scrap',
    tracksTaken: '{n} Scrap taken',
    locked: 'Locked',
    notBuilt: 'Not built',
    busyOther: '{name} is already being built. One project at a time.',
    waitFor: 'Wait for {name}',
    crafting: 'Crafting · {time}',
    open: 'Open',
    sheetUpgrade: 'Upgrade {name}',
    sheetBuild: 'Build {name}',
    now: 'Now',
    next: 'Level {n}',
    /** 1. 10. 2026 (C2): the energy a finished level gives (ENERGY_RULES.building). */
    /** 7. 10. 2026 (owner, energy test): the maximum by the Medical Tent. */
    energyMaxLabel: 'Energy',
    energyMax: 'Max energy {a} → {b}',
    whenDone: 'When done',
    energy: '+{n} energy',
    cost: 'Cost',
    time: 'Build time',
    requires: 'Requires survivor level {n}',
    confirmUpgrade: 'Upgrade to LV {n}',
    confirmBuild: 'Build it',
    missing: 'Missing {list}',
    inProgress: 'Upgrading to LV {n} · {time} left',
    /** 1. 10. 2026: the upgrade block shared by the building sheet and the Workshop header. */
    upgradingTo: 'Upgrading to LV {n}',
    missingOne: 'Missing {n} {name}',
    missingMany: 'Missing {n} resources',
    waiting: 'Waiting for {name}',
    short: '{n} short',
    readyOf: '{n} of {m} ready',
    levelChip: 'Survivor LV {n}',
    upgradeIn: '{label} · {time}',
    openWorkshop: 'Open workshop',
    started: '{name}: work started',
    /** Krug 5 (K4.16): the camp panorama on top of the screen. */
    panorama: 'Your camp',
    panoramaOpen: '{name}, LV {n}',
    panoramaNotBuilt: '{name}, not built',
    panoramaLocked: '{name}, unlocks at level {n}',
    /** 26. 9. 2026: the state line under each building in the panorama. */
    statusMax: 'Max',
    statusLevel: 'Needs Lv {n} to upgrade',
    statusUnlocks: 'Unlocks at Lv {n}',
    statusWait: 'Waiting',
    statusBuildingTip: 'Going up to LV {n}',
    /**
     * 23. 10. 2026 (owner, a player's feedback): the building site in the sheet: resources toward the next level that leave
     * Storage (no room) and can't be taken back; also while the level is still locked.
     */
    site: 'Building site',
    siteOf: '{n} / {m} on site',
    siteExplain: "Put what Storage has toward LV {n} now. It leaves Storage, so it takes no room. You can't take it back.",
    siteLocked: "Needs Lv {lv} to upgrade, but you can put what Storage has toward LV {n} now. It leaves Storage, so it takes no room. You can't take it back.",
    sitePut: 'Put toward it',
    siteNothing: 'Nothing in Storage for it',
    siteFull: 'Everything for LV {n} is on the site.',
    /** 23. 10. 2026: Scrap stays in Storage until the upgrade starts. */
    siteScrap: 'Scrap takes no Storage room: it stays with you and is paid when you start the upgrade.',
    siteOpensAt: 'From level {n} you can put resources toward LV {m} before you build it.',
    siteDone: 'Put toward {name}: {list}',
  },
  scout: {
    title: 'Scouts',
    body: 'Your Barricade scouts run a one-hour loop and drop the haul in Storage.',
    /** 1. 10. 2026: the Barricade's extra loot, and a place that needs a higher Barricade. */
    bonus: 'Barricade: +{n}% haul.',
    needs: 'Barricade LV {n}',
    sendShort: 'Send',
    send: 'Send to {zone}',
    out: 'Out in {zone}',
    back: 'Back in {time}',
    lastHaul: 'Last haul',
    none: 'Nothing yet',
    sent: 'Scouts sent to {zone}',
    /** 2. 10. 2026 (package 1, 5.b): the loop queue, and a haul cut by a full Storage. */
    keep: 'Keep searching',
    /** 3. 10. 2026 (owner): the scouts stop at 80% of Storage. */
    keepSub: "Up to {n} loops in a row ({h}); every loop after the first brings {share}%. The scouts stop when Storage is {p}% full, so there's room for what your survivor brings back.",
    loop: 'Loop {n} of {m}',
    allBack: 'all back at {t}',
    full: 'Storage was {p}% full: the scouts stopped and the rest of the last haul stayed out there.',
    /** 28. 10. 2026 (owner, fb-balance): a place's resources are toggles; what is off stays out there. */
    brings: 'What the scouts bring from {zone}',
    skipHint: 'Tap a resource to leave it out there. The scouts drop what they find of it, so the haul is smaller, never more of the rest. Your choice is kept for each place.',
    lastOn: 'At least one stays on.',
    leaving: 'Leaving behind: {list}',
  },
  world: {
    title: 'World',
    live: 'Live',
    online: '{n} online',
    openFeed: 'Open feed →',
    empty: 'Quiet out there. For now.',
  },
  horde: {
    live: 'Horde · live',
    soon: 'Horde incoming',
    startsIn: 'Starts in {time}',
    endsIn: 'Ends in {time}',
    join: 'Join the fight',
    view: 'View',
    /** Krug 5 (K16.2) */
    joinFromLv: 'Join from Lv {n}',
    /** 2. 10. 2026 (package 1, 10.b): the forecast row before the horde starts. */
    forecast: '{zone} · ~{hp} to break · militia about {pct}%',
    /** Package 4, part F: the kind and its rule; a Sunday boss's three phases; the strength against last time. */
    kind: '{name}: {rule}',
    phases: 'Three phases: {names}',
    strength: 'Strength {p}%',
    /** F4: Stand guard on the Camp card (from noon until the horde comes). */
    guard: 'Stand guard',
    guardAdd: '+1 wave',
    guardOn: 'On guard: {n} of {max} waves',
    guardHint: 'Not here at {t}? Prepay waves: your survivor fights them without you.',
    guardOpens: 'Stand guard opens at {t}',
  },
  stance: 'Stance',
  /** Krug 5 (K17.3): Camp at 0 energy. */
  outOfEnergy: {
    title: 'Out of energy',
    craft: 'Craft at the Workshop',
    trade: 'Trade with Tobias',
    skills: 'Learn skills',
  },
  /** Krug 5 (K6.2): the auto-dismantle offer. */
  autoPrompt: {
    title: 'Storage is filling up',
    body: 'Common gear is mostly Scrap. Dismantle it automatically when you come back?',
    also: 'Also dismantle the {n} Common items I have now',
    alsoOne: 'Also dismantle the 1 Common item I have now',
    turnOn: 'Turn on',
    notNow: 'Not now',
    done: 'Auto-dismantle is on',
    doneOne: 'Auto-dismantle is on. 1 item dismantled: {gain}',
    doneMany: 'Auto-dismantle is on. {n} items dismantled: {gain}',
  },
  /** 7. 10. 2026 (owner): worn gear under 20% or broken. */
  gearWear: {
    title: 'Gear wearing out',
    repair: 'Repair',
    cost: 'Repair now: {what}',
    costBroken: 'In the Workshop: {time}, {what}',
    /** 28. 10. 2026 (player report): what the player has next to what it takes (the plain line until Storage is loaded). */
    costBrokenShards: 'In the Workshop: {time} · {n} of your {have} Relic Shards, {what}',
    costBrokenShardsPlain: 'In the Workshop: {time} · {n} Relic Shards, {what}',
  },
  storageFull: {
    upgrade: 'Upgrade Storage',
    /** 23. 10. 2026 (owner, a player's feedback): dismantling no longer offered here; why. */
    why: 'Each piece of gear here takes 1 room. Dismantling frees that 1, but its materials come back to Storage and usually take more.',
    discard: 'Discard surplus',
    /** Krug 5 (K11.3): once the Trader is at camp, the button opens his Sell tab. */
    sellOrDiscard: 'Sell or discard surplus',
  },
  /** 7. 10. 2026 (owner): the generator at Station 9. */
  generator: {
    title: 'Generator',
    running: 'Running today: the Workshop crafts {p}% faster.',
    idle: 'Burns {f} Fuel a day. While it runs, the Workshop crafts {p}% faster.',
    noFuel: 'Out of Fuel: no bonus today. It starts again when Storage has {f} Fuel.',
    on: 'Turn on',
    off: 'Turn off',
    fuel: 'Fuel in Storage: {n}',
  },
  /** 7. 10. 2026 (owner): fire barrels in the hour before the horde. */
  barrels: {
    title: 'Fire barrels',
    body: 'The horde reaches the {zone} at {time}. Light the barrels and the horde burns in every wave you fight tonight: {p}% of your attack every round.',
    light: 'Light them · {f} Fuel',
    lit: 'Your barrels are burning. Join the horde when it comes.',
    short: 'You need {f} Fuel. You have {n}.',
  },
} as const;
